import postBrowseFeedback, {
  BrowseFeedbackSentiment,
} from '@cartwhl/common/api/postBrowseFeedback';
import Tooltip from '@cartwhl/ui/atoms/Tooltip';
import Button from '@cartwhl/ui/input/Button';
import Heart from '@cartwhl/ui/messaging/Heart';

import { animationGenerationStore, noticesStore } from 'stores';

import { useLibraryStore } from '../useLibraryStore';

type Props = {
  jobID: string;
  title: string;
  showNotification?: boolean;
  className?: string;
};

export default function BrowseHeartIcon({
  jobID,
  title,
  className = '',
}: Props) {
  const { favorites, addToFavorites, removeFromFavorites } = useLibraryStore();

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const shouldAdd = !favorites.has(jobID);
    if (shouldAdd) {
      addToFavorites(jobID);
    } else {
      removeFromFavorites(jobID);
    }

    const result = await animationGenerationStore.setFavorite(
      jobID,
      0,
      shouldAdd,
      true,
      false,
    );
    if (result?.success) {
      noticesStore.success(
        `${title} ${shouldAdd ? 'added to' : 'removed from'} favorites!`,
      );
    }
    if (shouldAdd) {
      const { error } = await postBrowseFeedback({
        jobID: jobID,
        sentiment: BrowseFeedbackSentiment.HEARTS,
        reason: '',
      });
      if (error) {
        console.error(error);
      }
    }
  };

  return (
    <Tooltip text={`Add to favorites`} inModal={true}>
      <Button
        id="loving-this"
        icon={<Heart value={favorites.has(jobID)} size="sm" />}
        variant="secondary"
        size="sm"
        className={className}
        onClick={handleClick}
      />
    </Tooltip>
  );
}
